import { DATE_FORMATS } from '@admiin-com/ds-common';
import {
  InvoiceStatus,
  PaymentFrequency,
  PaymentType,
} from '@admiin-com/ds-graphql';
import { t } from 'i18next';
import { DateTime } from 'luxon';

export const validateDate = (value: any) => {
  if (!value || typeof value !== 'string') {
    return t('dateInvalid', { ns: 'taskbox' });
  }
  if (!DateTime.fromFormat(value, DATE_FORMATS.BACKEND_DATE).isValid) {
    return t('dateInvalid', { ns: 'taskbox' });
  }
  return true;
};

export const TASK_FORM_FIELDS = {
  emailMessage: {
    name: 'emailMessage',
    type: 'text',
    placeholder: t('emailMessagePlaceholder', { ns: 'taskbox' }),
    label: t('emailMessage', { ns: 'taskbox' }),
    defaultValue: undefined,
  },
  from: {
    label: t('from', { ns: 'taskbox' }),
    name: 'from' as const,
    type: 'text',
    defaultValue: undefined,
    placeholder: t('entitySearchPlaceholder', { ns: 'taskbox' }),
    rules: { required: t('fromRequired', { ns: 'taskbox' }) },
  },
  to: {
    label: t('to', { ns: 'taskbox' }),
    name: 'to' as const,
    type: 'text',
    defaultValue: undefined,
    placeholder: t('selectContact', { ns: 'taskbox' }),
    rules: { required: t('toRequired', { ns: 'taskbox' }) },
  },
  paymentFrequency: {
    label: t('paymentFrequency', { ns: 'taskbox' }),
    name: 'paymentFrequency' as const,
    type: 'text',
    placeholder: t('selectOption', { ns: 'taskbox' }),
    defaultValue: PaymentFrequency.ONCE,
    rules: { required: t('paymentFrequencyRequired', { ns: 'taskbox' }) },
  },
  paymentTypes: {
    label: t('paymentOptions', { ns: 'taskbox' }),
    name: 'paymentTypes' as const,
    type: 'text',
    placeholder: t('selectOption', { ns: 'taskbox' }),
    defaultValue: PaymentType.PAY_NOW,
    rules: { required: t('paymentOptionRequired', { ns: 'taskbox' }) },
  },
  allowExtendedTerms: {
    label: t('allowExtendedTerms', { ns: 'taskbox' }),
    name: 'allowExtendedTerms' as const,
    type: 'checkbox',
    defaultValue: false,
    placeholder: '',
    rules: {},
  },
  maximumInstallments: {
    label: t('maximumInstallments', { ns: 'taskbox' }),
    name: 'maximumInstallments' as const,
    type: 'text',
    placeholder: t('selectOption', { ns: 'taskbox' }),
    defaultValue: 3,
    rules: {
      required: t('maximumInstallmentsRequired', { ns: 'taskbox' }),
    },
  },
  numberOfPayments: {
    label: t('numberOfPayments', { ns: 'taskbox' }),
    name: 'numberOfPayments' as const,
    type: 'number',
    placeholder: 'e.g. 6',
    rules: {
      validate: (value: any) => {
        if (!Number.isInteger(Number(value))) {
          return t('numberPaymentsMustBeInteger', { ns: 'taskbox' });
        }
        if (value < 2 || value > 24) {
          return t('numberPaymentsMinMax', { ns: 'taskbox' });
        }
        return true;
      },
    },
  },

  paymentAt: {
    label: t('paymentAt', { ns: 'taskbox' }),
    name: 'paymentAt' as const,
    type: 'date' as const,
    placeholder: 'dd/mm/yyyy',
    defaultValue: '',
    rules: {
      validate: validateDate,
    },
  },
  firstPaymentAt: {
    label: t('firstPaymentAt', { ns: 'taskbox' }),
    name: 'firstPaymentAt' as const,
    type: 'date' as const,
    placeholder: 'dd/mm/yyyy',
    defaultValue: '',
    rules: {
      required: t('firstPaymentAtRequired', { ns: 'taskbox' }),
      validate: validateDate,
    },
  },
  dueAt: {
    label: t('dueAt', { ns: 'taskbox' }),
    name: 'dueAt' as const,
    type: 'date' as const,
    placeholder: 'dd/mm/yyyy',
    defaultValue: DateTime.now()
      .setZone('Australia/Sydney')
      .toFormat(DATE_FORMATS.BACKEND_DATE),
    rules: {
      required: t('dueAtRequired', { ns: 'taskbox' }),
      validate: validateDate,
    },
  },
  issuedAt: {
    label: t('issuedAt', { ns: 'taskbox' }),
    name: 'issuedAt' as const,
    type: 'date' as const,
    placeholder: 'dd/mm/yyyy',
    defaultValue: DateTime.now()
      .setZone('Australia/Sydney')
      .toFormat(DATE_FORMATS.BACKEND_DATE),
    rules: {
      // validate: validateDate,
    },
  },
  supportDocuments: {
    label: t('supportingDocuments', { ns: 'taskbox' }),
    name: 'supportDocuments' as const,
    type: 'file' as const,
    defaultValue: [],
    placeholder: t('selectFile', { ns: 'taskbox' }),
    rules: {},
  },
  note: {
    label: t('comments', { ns: 'taskbox' }),
    name: 'notes' as const,
    type: 'text',
    defaultValue: undefined,
    rules: {},
  },
  invoiceStatus: {
    label: t('invoiceStatus', { ns: 'taskbox' }),
    name: 'invoiceStatus' as const,
    type: 'text',
    defaultValue: InvoiceStatus.INVOICE,
    rules: {},
  },
  reference: {
    label: t('referenceNumber', {
      ns: 'taskbox',
    }),
    name: 'reference' as const,
    type: 'text',
    placeholder: `INV34356`,
    defaultValue: undefined,
    rules: {
      validate: {
        referenceIsRequired: (value: string) => {
          if (!value) {
            return t('referenceRequired', { ns: 'taskbox' });
          }
          //else if (
          //  type !== TaskType.SIGN_ONLY &&
          //  value &&
          //  value.length > 18
          //) {
          //  return t('referenceTooLong', { ns: 'taskbox', max: 18 });
          //}

          //TODO: disabled for now - implemented to prevent invalid reference on bank statement. Can do with solution with string replace on server - Zai
          //else if (!/^[a-zA-Z0-9\s.\-():]+$/.test(value)) {
          //  return t('invalidReferenceCharacter', { ns: 'taskbox' });
          //}

          return true;
        },
      },
    },
  },
  endAt: {
    label: t('endAt', { ns: 'taskbox' }),
    name: 'endAt' as const,
    type: 'date' as const,
    placeholder: 'dd/mm/yyyy',
    defaultValue: '',
    rules: {
      validate: validateDate,
    },
  },
  recurringType: {
    label: t('recurringType', { ns: 'taskbox' }),
    name: 'recurringType' as const,
    type: 'text',
    defaultValue: 'never',
    rules: {},
  },
};
